module.exports = __webpack_public_path__ + "img/lr-cb5-y1.eddea639.gif";